import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {parseLink, upperCaseFirstLetter} from '../../../../../../utils';
import {useDispatch, useSelector} from "react-redux";
import Button from '../../../../../../components/button';
import LabelIcon from "../../../list-of-groups/components/label/components/label-icon";
import CommentsList
from "../../../sharing-details-popup/components/contact-details-popup/components/contact-content/components/comments-list";
import {findComments, findNextComments} from '../../../../../../../actions/commentActions';
import SharingPreview from "../../../../../../components/sharing-preview";
import SharingLabelButton from "../../../list-of-groups/components/label/components/sharing-label-button";
import ContactEdit from '../../../sharing-details-popup/components/contact-details-popup/components/contact-edit';
import {
	putLabelToRemoveFromContactDetails
} from '../../../../../../../actions/contactActions';
import Icon from "../../../../../../components/icon";
import {getSharingDetailsPopup} from "../../../../../../../actions/sharingDetailsActions";
import PicButton from "../../../../../../components/pic-button";
import {labelStateUpdating} from "../../../../../../../actions/contactsGroupItemActions";
import {isDirectoryV5AccessPopupShown as setIsDirectoryV5AccessPopupShown} from '../../../../../../../actions/popupActions';
import './index.css';

function ContactDetailsBody ({contactDetails, history, location}) {

	const [commentPageNumber, setCommentPageNumber] = useState(1);

	const { t } = useTranslation();

	const labels = useSelector(state => state.contactsGroupItemReducer.findLabels);
	const comments = useSelector(state => state.commentReducer.findComments);
	const selectedContactsGroup = useSelector( state => state.contactsGroupItemReducer.getSelectedContactsGroup);
	const profile = useSelector(state => state.profileReducer.getProfile);

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(findComments(contactDetails.id, 3));
	}, [dispatch, contactDetails]);

	const previewComments = () => {
		dispatch(findNextComments(contactDetails.id, 3, commentPageNumber + 1));
		setCommentPageNumber(commentPageNumber + 1);
	};

	const handleEdit = () => {
		if(contactDetails.phoneContactEntry.type === "directory"){
			if(profile.accessStatus.isCustomSchemaAndDirectoryWriteGranted === false){
				dispatch(setIsDirectoryV5AccessPopupShown(true));
			} else {
				history.push('/contact/' + contactDetails.id + '/edit');
			}
		} else {
			history.push('/contact/' + contactDetails.id + '/edit');
		}
	};

	const handleAddToOtherLabel = () => {
		dispatch(getSharingDetailsPopup([true, 'select_one_label', [{
			'id': contactDetails.id,
			'type': contactDetails.phoneContactEntry.type
		}], contactDetails.name]));
	};

	const handleRemoveFromLabel = (e) => {
		dispatch(labelStateUpdating(selectedContactsGroup.id));
		dispatch(putLabelToRemoveFromContactDetails(
			selectedContactsGroup.ownerId,
			e.currentTarget.dataset.id,
			e.currentTarget.dataset.ownerId,
			contactDetails.id,
			contactDetails.phoneContactEntry.type
		));
	};

	if(location.pathname === "/contact/" + contactDetails.id + "/edit"){
		return (
			<div className="mb-5">
				<ContactEdit/>
			</div>
		)
	} else {
		return (
			<div className="contact-details-body">
				<div className="col-12 col-xl-5 p-0">
					<div className="contact-details-body__box mb-4">
						<div className="editBtn">
							<Button onClick={handleEdit} className="btn-link p-0" disabled={selectedContactsGroup === null || (contactDetails.editable === false && contactDetails.phoneContactEntry.type !== 'directory')}>
								<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path fillRule="evenodd" clipRule="evenodd" d="M12.2565 4.07689L14.5 1.83334C15.3588 0.9746 15.7881 0.545232 16.2903 0.403555C16.6454 0.303388 17.0213 0.303388 17.3764 0.403555C17.8786 0.545232 18.3079 0.9746 19.1667 1.83334C20.0254 2.69207 20.4548 3.12144 20.5965 3.62366C20.6966 3.97874 20.6966 4.3546 20.5965 4.70968C20.4548 5.2119 20.0254 5.64127 19.1667 6.5L16.9492 8.7175C15.0027 7.6014 13.3871 5.99799 12.2565 4.07689ZM10.8021 5.53126L2.52306 13.8103C2.098 14.2354 1.88547 14.4479 1.74574 14.709C1.606 14.9701 1.54706 15.2648 1.42917 15.8543L0.647104 19.7646C0.580582 20.0972 0.547321 20.2635 0.641929 20.3581C0.736533 20.4527 0.902829 20.4194 1.23541 20.3529L1.23544 20.3529L1.23545 20.3529L5.14577 19.5709L5.14578 19.5708C5.73522 19.453 6.02995 19.394 6.29104 19.2543C6.55214 19.1145 6.76467 18.902 7.18973 18.477L15.4911 10.1756C13.5955 8.99522 11.9942 7.40501 10.8021 5.53126Z" fill="#314D60"/>
								</svg>
							</Button>
						</div>
						<h3>{ t('contactDetails') }</h3>
						{
							contactDetails.phoneContactEntry.note &&
							<div className="d-flex">
								<svg width="20" height="20" viewBox="0 0 24 24" fill="none"
								     xmlns="http://www.w3.org/2000/svg">
									<path fill="none" stroke="#314D60" strokeWidth="2" d="M6.417,2.792h11.166c1.104,0,2,0.895,2,2v14.416c0,1.104-0.896,2-2,2H6.417
                            c-1.104,0-2-0.896-2-2V4.792C4.417,3.687,5.313,2.792,6.417,2.792z"/>
									<path fill="none" stroke="#314D60" strokeWidth="2" strokeLinecap="round"
									      d="M8.75,8.208h6.5"/>
									<path fill="none" stroke="#314D60" strokeWidth="2" strokeLinecap="round"
									      d="M8.75,12.542h6.5"/>
									<path fill="none" stroke="#314D60" strokeWidth="2" strokeLinecap="round"
									      d="M8.75,16.874h4.334"/>
								</svg>
								<p className="pl-3">{parseLink(contactDetails.phoneContactEntry.note)}</p>
							</div>
						}
						{
							contactDetails.phoneContactEntry.phoneNumbers &&
							<div className="phone-numbers">
								{
									contactDetails.phoneContactEntry.phoneNumbers.map((phoneNumber, index) => (
										<div key={index} className="d-flex phone-number">
											<svg width="20" height="20" viewBox="0 0 24 24">
												<path fill="none" d="M0 0h24v24H0V0z"/>
												<path
													d="M6.54 5c.06.89.21 1.76.45 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79h1.51m9.86 12.02c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19M7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57-.1-.04-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.45-5.15-3.76-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1z"/>
											</svg>
											<p className="pl-3"><a href={"tel:" + phoneNumber.number} target="_blank"
											                       rel="noreferrer">{phoneNumber.number}</a> {phoneNumber.label ?
												<span
													className="field-type">• {upperCaseFirstLetter(phoneNumber.label)}</span> : ''}
											</p>
										</div>
									))
								}
							</div>
						}
						{
							contactDetails.phoneContactEntry.emailAddresses &&
							<div className="email-addresses">
								{
									contactDetails.phoneContactEntry.emailAddresses.map((emailAddress, index) => (
										<div key={index} className="d-flex email-address">
											<svg width="20" height="20" viewBox="0 0 24 24"
											     xmlns="http://www.w3.org/2000/svg">
												<path d="M0 0h24v24H0V0z" fill="none"/>
												<path
													d="M22 6c   0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z"/>
											</svg>
											<p className="pl-3"><a href={"mailto:" + emailAddress.email} target="_blank"
											                       rel="noreferrer">{emailAddress.email}</a> {emailAddress.label ?
												<span
													className="field-type">• {upperCaseFirstLetter(emailAddress.label)}</span> : ''}
											</p>
										</div>
									))
								}
							</div>
						}
						{
							contactDetails.phoneContactEntry.postalAddresses &&
							<div className="postal-addresses">
								{
									contactDetails.phoneContactEntry.postalAddresses.map((postalAddress, index) => (
										<div key={index} className="d-flex postal-address">
											<svg width="20" height="20" viewBox="0 0 24 24">
												<path fill="none" d="M0 0h24v24H0V0z"/>
												<path
													fill="#314D60"
													d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z"/>
												<circle cx="12" cy="9" r="2.5"/>
											</svg>
											<ul className="list-unstyled pl-3">
												{
													postalAddress.street && <li>{postalAddress.street}</li>
												}
												{
													postalAddress.neighborhood && <li>{postalAddress.neighborhood}</li>
												}
												{
													postalAddress.postCode && <li>{postalAddress.postCode}</li>
												}
												{
													postalAddress.city && <li>{postalAddress.city}</li>
												}
												{
													postalAddress.state && <li>{postalAddress.state}</li>
												}
												{
													postalAddress.region && <li>{postalAddress.region}</li>
												}
												{
													postalAddress.country && <li>{postalAddress.country}</li>
												}
												{
													postalAddress.label && <li>{postalAddress.label}</li>
												}
											</ul>
										</div>
									))
								}
							</div>
						}
						{
							contactDetails.phoneContactEntry.birthday &&
							<div className="d-flex">
								<svg width="20" height="20" viewBox="0 0 24 24">
									<path d="M0 0h24v24H0V0z" fill="none"/>
									<path
										fill="#314D60"
										d="M19 14v-4c0-1.1-.9-2-2-2h-4V6.55c.15-.09.29-.18.41-.31.39-.39.59-.92.59-1.42s-.2-1.02-.59-1.41L12 2l-1.41 1.41c-.39.39-.59.91-.59 1.41s.2 1.03.59 1.42c.13.13.27.22.41.31V8H7c-1.1 0-2 .9-2 2v4c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zM7 10h10v4H7v-4zm12 10H5v-4h14v4z"/>
								</svg>
								<p className="pl-3">{`
                            ${
									contactDetails.phoneContactEntry.birthday.month > 9
										?
										contactDetails.phoneContactEntry.birthday.month
										:
										'0' + contactDetails.phoneContactEntry.birthday.month
									}
                            /
                            ${
									contactDetails.phoneContactEntry.birthday.day > 9
										?
										contactDetails.phoneContactEntry.birthday.day
										:
										'0' + contactDetails.phoneContactEntry.birthday.day
									}
                            /
                            ${
									contactDetails.phoneContactEntry.birthday.year
									}
                        `}</p>
							</div>
						}
						{
							contactDetails.phoneContactEntry.userDefined && <div className="custom-fields">
								{
									contactDetails.phoneContactEntry.userDefined.filter((item) => item.value !== "").map((item, index) => (
										<div key={index} className="d-flex custom-field">
											<svg
												height="20"
												viewBox="0 -960 960 960"
												width="20"
											>
												<path
													d="M200-520q-33 0-56.5-23.5T120-600v-160q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v160q0 33-23.5 56.5T760-520H200Zm0-80h560v-160H200v160Zm0 480q-33 0-56.5-23.5T120-200v-160q0-33 23.5-56.5T200-440h560q33 0 56.5 23.5T840-360v160q0 33-23.5 56.5T760-120H200Zm0-80h560v-160H200v160Zm0-560v160-160Zm0 400v160-160Z"/>
											</svg>
											<p className="pl-3">
												<strong>{item.key}</strong>: {parseLink(item.value)}
											</p>
										</div>
									))
								}
							</div>
						}
					</div>
					<div className="contact-details-body__box mb-4 mb-md-0">
						<h3>{t('contactDetailsContactSharedInTitle')}</h3>
						<div className="mb-4">
							{
								labels
								?
									labels.contactsGroups.filter(item => contactDetails.labels.map(label => label.id).includes(item.id)).map(item => (
										<div key={item.id}
											className="d-flex align-items-center justify-content-between position-relative">
											<div className="text-truncate">
												<LabelIcon status={item.status}/> <span title={item.name}>{item.name} ({item.nbOfContact})</span>
											</div>
											<div className="d-flex align-items-center justify-content-end">
												<div>
													<PicButton
														data-id={item.id}
														data-owner-id={item.ownerId}
														onClick={ handleRemoveFromLabel }>
														<Icon name="chain-broken"/>
													</PicButton>
												</div>
												<SharingPreview
													permission={item.permission}
													labelId={item.id}
													collaborators={item.sharingPreview}
													sharingNumber={item.sharingNumber}
													status={item.status}
												/>
												{
													(item.permission === 'OWNER' || item.permission === 'CAN_SHARE') && selectedContactsGroup !== null
													?
														<SharingLabelButton labelId={item.id} labelName={item.name} title={t("texthoveronshare")}/>
													:
														<SharingLabelButton disabled={true} labelId={item.id} labelName={item.name} title={t("texthoveronshare")}/>

												}
											</div>
										</div>
									))
								:
									null
							}
						</div>
						<div className="text-center">
							<Button className="btn-responsive btn-link font-weight-normal text-left" onClick={handleAddToOtherLabel}>
								<Icon className="mr-2" name="plus-circle"/>{t("addToAnotherLabel")}
							</Button>
						</div>
					</div>
				</div>
				<div className="col-12 col-xl-7 pl-md-3">
					<h3>{t('textComments')}</h3>
					{
						comments && comments.commentResponses.length > 0 && (
							<div className="view-preview-notes">
								{
									comments.commentResponses.length !== comments.pagesInfo.totalRecords &&
									<div>
										<button onClick={previewComments}
												className="btn btn-link p-0 font-weight-normal">
											View previous notes
										</button>
									</div>
								}
								<div className="ml-auto">
									{comments.commentResponses.length} of {comments.pagesInfo.totalRecords}
								</div>
							</div>
						)
					}
					<CommentsList contactDetails={contactDetails}/>
				</div>
			</div>
		)
	}
}

export default ContactDetailsBody;
